import React from "react";
import { string } from "prop-types";

import "./textfield.m.css";

const TextField = ({ value, type, error, ...props }) => (
  <div styleName="wrapper" className="wrapper-textfield">
    <input type={type} value={value || ""} styleName="textfield" className="textfield" {...props} />
    {error && <span styleName="error">{error}</span>}
  </div>
);

TextField.defaultProps = {
  type: "text",
};

TextField.propTypes = {
  type: string,
  value: string,
  error: string,
};

export default TextField;
